import { MaintenanceStatus } from '../../types/maintenanceStatus';

export const SET_MAINTENANCE_STATUSES = 'SET_MAINTENANCE_STATUSES';

export class SetMaintenanceStatuses {
  readonly type = SET_MAINTENANCE_STATUSES;
  readonly payload: MaintenanceStatus[];

  constructor(statuses: MaintenanceStatus[]) {
    this.payload = statuses;
  }
}

export type Action = SetMaintenanceStatuses;
